import request from '@/utils/request'

// 获取bunner列表
export async function api_getBanner(params) {
  return request({
    url: '/rest/banner/page',
    method: 'get',
    params,
  })
}
// 修改banner状态
export async function api_putBannerStatus(params) {
  return request({
    url: '/rest/banner/status',
    method: 'put',
    params,
  })
}
// 新增banner
export async function api_postAddBanner(data) {
  return request({
    url: '/rest/banner',
    method: 'post',
    data,
  })
}
// 修改banner
export async function api_putUpdateBanner(data) {
  return request({
    url: '/rest/banner',
    method: 'put',
    data,
  })
}
// 删除banner
export async function api_deleteBanner(params) {
  return request({
    url: '/rest/banner',
    method: 'delete',
    params,
  })
}
// 查看banner详情
export async function api_getBannerDetail(params) {
  return request({
    url: '/rest/banner',
    method: 'get',
    params,
    loading: true
  })
}
export async function api_getSize() {
  return request({
    url: '/rest/banner/getSize',
    method: 'get',
  })
}
